module.exports = __webpack_public_path__ + "img/pipes.282fa531.jpg";